import { render, staticRenderFns } from "./CountersNewValueForm.vue?vue&type=template&id=3047d013&scoped=true&"
import script from "./CountersNewValueForm.vue?vue&type=script&lang=ts&"
export * from "./CountersNewValueForm.vue?vue&type=script&lang=ts&"
import style0 from "./CountersNewValueForm.vue?vue&type=style&index=0&id=3047d013&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3047d013",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
